export const errorsRefs = {
  INSUFFICIENT_FUNDS: "insufficientFunds",
  TIME_LIMIT_EXCEEDED: "timeLimitExceeded",
  GENERIC_ERROR: "genericError",
  DISCONNECTED: "disconnected",
  LOCATION_FORBIDDEN: "locationForbidden",
  NOT_LOGGED_IN: "notLoggedIn",
  PLAY_FOR_REAL: "playForReal",
  LOSS_LIMIT: "lossLimit",
  TIME_LIMIT: "timeLimit",
  TURNOVER_LIMIT: "turnoverLimit",
  LIFETIME_DEPOSIT: "lifetimeDeposit",
  DEPOSIT_LIMIT: "depositLimit",
}

export const ERROR_MESSAGES = {
  [errorsRefs.LOSS_LIMIT]: 'The player has reached their loss limit',
  [errorsRefs.TURNOVER_LIMIT]: 'The player has reached their wager limit',
  [errorsRefs.LIFETIME_DEPOSIT]: 'The player has reached their lifetime deposit limit',
  [errorsRefs.DEPOSIT_LIMIT]: 'The player has reached their deposit limit',
  [errorsRefs.TIME_LIMIT]: 'The player has reached their time limit',
};

export const getErrorMessage = (code: string): string =>
  ERROR_MESSAGES[code as keyof typeof ERROR_MESSAGES] || 'An unknown error has occurred';
